import { valtioDevTools } from '@lib/utils/devTools';
import { proxy, subscribe } from 'valtio';
import Task from './Task';
import { writePersistedTasks } from './lib/taskPersistence';
import { Campaign } from '@api/queries/getCampaign';
import { Workflow } from '@api/queries/getWorkflowNameByPhoneNumber';

type CampaignCacheEntry = {
  campaign: Campaign | null;
  fetchedAt: number;
};

type WorkflowCacheEntry = {
  workflow: Workflow | null;
  fetchedAt: number;
};

export type TasksState = {
  version: number;
  tasks: Record<string, Task>;
  phoneNumberToCampaign: Record<string, Record<string, CampaignCacheEntry>>; // tenantId -> phoneNumber -> entry
  phoneNumberToWorkflow: Record<string, WorkflowCacheEntry>; // phoneNumber -> entry
};

export const tasksState = proxy<TasksState>({
  version: 0,
  tasks: {},
  phoneNumberToCampaign: {},
  phoneNumberToWorkflow: {},
});

valtioDevTools(tasksState, 'tasksState');

subscribe(tasksState, () => {
  writePersistedTasks(tasksState.tasks);
});

export function setMockedTasks(tasks: Task[]) {
  const tasksMap: Record<string, Task> = {};
  tasks.forEach((task) => (tasksMap[task.id] = task));
  tasksState.tasks = tasksMap;
}
